var initValidateForm = function () {

    var ValidateFormModule = {
        settings: {
            contentBlock: '#content-block',
            subscribeFormId: '#subscribeForm',
            contactFormId : '#contactForm'
        }
    }
    var handleSubscribeFormValidate = function () {

        const form = $(ValidateFormModule.settings.subscribeFormId);
        form.validate({

            errorClass: "text-danger",
            errorElement: "span",

            rules: {
                nl_name: {
                    required: true,
                    maxlength: 255,
                    minlength: 2
                },
                nl_email: {
                    required: true,
                    email: true
                }
            },
            messages: {
                nl_name: {
                    required: Lang.get('js-validator-mess.required'),
                    maxlength: Lang.get('js-validator-mess.maxlength'),
                    minlength: Lang.get('js-validator-mess.minlength')
                },
                nl_email: {
                    required: Lang.get('js-validator-mess.required'),
                    email: Lang.get('js-validator-mess.email')
                }
            },

            highlight: function highlight(element, errorClass) {
                $(element).removeClass(errorClass);
            }
        });

        $('#submit_btn_nl').unbind("click");

        $('#submit_btn_nl').click(function (e) {
            e.preventDefault();
            const form = $(ValidateFormModule.settings.subscribeFormId);

            if (form.validate().form()) {

                initAppPage.blockUIStart(ValidateFormModule.settings.subscribeFormId);

                form.submit();

            }
            return false;
        });
    }

    var handleContactFormValidate = function () {

        const form = $(ValidateFormModule.settings.contactFormId);
        form.validate({

            errorClass: "text-danger",
            errorElement: "span",

            rules: {
                name: {
                    required: true,
                    maxlength: 255,
                    minlength: 2
                },
                email: {
                    required: true,
                    email: true
                },
                message: {
                    required: true,
                    maxlength: 500,
                    minlength: 3
                }
            },
            messages: {
                name: {
                    required: Lang.get('js-validator-mess.required'),
                    maxlength: Lang.get('js-validator-mess.maxlength'),
                    minlength: Lang.get('js-validator-mess.minlength')
                },
                email: {
                    required: Lang.get('js-validator-mess.required'),
                    email: Lang.get('js-validator-mess.email')
                },
                message: {
                    required: Lang.get('js-validator-mess.required'),
                    maxlength: Lang.get('js-validator-mess.maxlength'),
                    minlength: Lang.get('js-validator-mess.minlength')
                }
            },

            highlight: function highlight(element, errorClass) {
                $(element).removeClass(errorClass);
            }
        });

        $('#submit_btn_ctf').unbind("click");

        $('#submit_btn_ctf').click(function (e) {
            e.preventDefault();
            const form = $(ValidateFormModule.settings.contactFormId);

            if (form.validate().form()) {

                initAppPage.blockUIStart(ValidateFormModule.settings.contactFormId);

                form.submit();

            }
            return false;
        });
    }

    return {

        //main function to initiate the module
        init: function () {
            handleSubscribeFormValidate();
            handleContactFormValidate();
        }

    };

}();

jQuery(document).ready(function () {
    initValidateForm.init();
});
